import { useState, useEffect } from 'react';
import { StyledFooter, StyledContainer } from '@/components/styles'
import { Social, ContactsMap, ActiveLink } from '@/components'
import { social, phones, emailFooter, legalLinks } from '@/lib/config'
import { useRouter } from 'next/router'
import Icon from '@/assets/icons'
import { useTranslation } from "react-i18next";
import genLinkParams from '@/lib/generateLinkParams'
import * as gtag from '@/lib/gtag'
import { useHost } from '@/contexts/HostContext'
import { getCanonicalUrl } from '@/lib/locales'
import { buildWhatsAppUrl } from '@/lib/attribution'

const footerLegalLink = {
  href: legalLinks.personalDataProcessingPolicy,
}

export default function Footer({ menu, isMap = true, isBottom = true, isTop, stretch, h1 }) {
  const { t } = useTranslation("global");
  const [legalRightsHref, legalRightsAs, legalRightsTitle] = genLinkParams({ type: 'legalRights' })
  const [legalFamilyBillHref, legalFamilyBillAs, legalFamilyBillTitle] = genLinkParams({ type: 'legalFamilyBill' })
  const [privacyPolicyHref, privacyPolicyAs, privacyPolicyTitle] = genLinkParams({ type: 'privacyPolicy' })
  const router = useRouter();
  const host = useHost();
  const pageUrl = getCanonicalUrl(router?.asPath || '/', host);
  const [whatsappHref, setWhatsappHref] = useState(null);

  useEffect(() => {
    const item = social.find((s) => s.name.toLowerCase() === 'whatsapp');
    if (item) setWhatsappHref(buildWhatsAppUrl(item.href, pageUrl));
  }, [pageUrl]);
  return (
    <StyledFooter stretch={stretch} hideMargin={!isTop}>
      <StyledFooter.Main hiddenBlock={!isTop}>
        {isMap && <StyledFooter.Map>
          <ContactsMap coords={[25.12268331150143, 55.12573902596093]} />
        </StyledFooter.Map>}
        <StyledFooter.Data>
          <StyledFooter.Title as={stretch ? 'h1' : 'h2'}>{h1 || t('contactUs')}</StyledFooter.Title>
          <StyledFooter.Block>
            <StyledFooter.List>
              {phones.map((phone, ind) => (
                <StyledFooter.Item key={ind}>
                  <Icon name={phone.icon} />
                  <StyledFooter.Link
                      href={phone.href}
                      onClick={() => gtag.gtag_report_conversion('AW-18230806173/QqvYCO2h770cEJ2NkPVD')}>{phone.title}</StyledFooter.Link>
                </StyledFooter.Item>
              ))}
              <StyledFooter.Item>
                <Icon name={emailFooter.icon} />
                <StyledFooter.Link href={emailFooter.href}>{emailFooter.title}</StyledFooter.Link>
              </StyledFooter.Item>
              <StyledFooter.Item>
                <Icon name="location-icon" />
                <StyledFooter.Link href="https://www.google.com/maps/place/?q=place_id:ChIJbRitGv9DXz4RxI3UUp4hA3g" >{t('contacts.address')}</StyledFooter.Link>
              </StyledFooter.Item>
              <StyledFooter.Item>
                <Icon name="time-icon" />
                <StyledFooter.Link as="span" noHover>{t('contacts.hours')}</StyledFooter.Link>
              </StyledFooter.Item>
            </StyledFooter.List>
          </StyledFooter.Block>
          <StyledFooter.SocialList>
            {social.map((item, ind) => {
              const { href, icon, name } = item;
              const isWhatsapp = name.toLowerCase() === "whatsapp";
              let _href = href;
              if (isWhatsapp) {
                _href = whatsappHref || `${href}?text=Hello!%20Writing%20from%20${encodeURIComponent(pageUrl)}%20`;
              }
              return <Social key={ind} href={_href} icon={icon} onClick={() => {
                if (isWhatsapp) {
                  gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD')
                }
              }
              }/>
            })}
          </StyledFooter.SocialList>
          <StyledFooter.Image>
            {/* <img src="/images/footerImg.png" alt="Sante" height={65} width={239}/> */}
          </StyledFooter.Image>
        </StyledFooter.Data>
      </StyledFooter.Main>
      {isBottom && <StyledFooter.Bottom>
        <StyledContainer>
          
          <StyledFooter.Text>{t('footer.approval')}</StyledFooter.Text>
          <StyledFooter.Text>{t('footer.licenses')}</StyledFooter.Text>
          <StyledFooter.Text>
            <StyledFooter.LegalLink as={"div"}>
              <ActiveLink href={privacyPolicyHref} as={privacyPolicyAs} addHrefActive={true}  activeAs={'a'}>
                <StyledFooter.Text as={"a"}>{privacyPolicyTitle}</StyledFooter.Text>             
              </ActiveLink>
            </StyledFooter.LegalLink> 
          </StyledFooter.Text>
          <StyledFooter.Text>
            <StyledFooter.LegalLink as={"div"}>
              <ActiveLink href={legalFamilyBillHref} as={legalFamilyBillAs} addHrefActive={true}  activeAs={'a'}>
                <StyledFooter.Text as={"a"}>{legalFamilyBillTitle}</StyledFooter.Text>
              </ActiveLink>
            </StyledFooter.LegalLink>
          </StyledFooter.Text>
          <StyledFooter.Text>{t('footer.name')}</StyledFooter.Text>
          {/* <StyledFooter.LegalLink
            href={footerLegalLink.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledFooter.Text mid>{t('footer.processingPersonal')}</StyledFooter.Text>
          </StyledFooter.LegalLink> */}
        </StyledContainer>
      </StyledFooter.Bottom>}
    </StyledFooter>
  )
}
